import React from "react";

import styles from "./PersonalTraining.module.scss";
import { PersonalTrainingPropsType } from "./types";
import personalTrainingImage from "@/assets/img/personalTraining.svg";
import personalTrainingImageMobile from "@/assets/img/personalTrainingMobile.svg";
import { TrainingAdvantageItem } from "../../components/trainingAdvantageItem/trainingAdvantageItem";
import { PersonalTrainingForm } from "../../Form/PersonalTrainingForm/PersonalTrainingForm";
import { SuccessModal } from "../../components/SuccessModal/SuccessModal";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

const trainingAdvantages = [
  'Улучшение координации движений',
  'Задействованы все группы мышц, и красивая спортивная фигура при систематических занятиях',
  'Развитие скорости и быстроты принятия решений',
];

export const PersonalTraining: React.FC<PersonalTrainingPropsType> = ({ title }) => {
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;
  const currentImage = isMobile ? personalTrainingImageMobile : personalTrainingImage;

  return (
    <main className={styles.main}>
      <section className="container">
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <h2 className={styles.title}>
              Персональные тренировки
            </h2>
            
            <p className={styles.description}>
              Индивидуальные занятия теннисом с тренером
            </p>

            <ul className={styles.trainingAdvantagesList}>
              {
                trainingAdvantages.map((advantage, index) => (
                  <TrainingAdvantageItem key={index} advantage={advantage} />
                ))
              }
            </ul>

            <PersonalTrainingForm />
          </div>
          <div className={styles.imageWrapper}>
            <img src={currentImage} alt="personal training" className={styles.image} />
          </div>
        </div>
      </section>

      <SuccessModal />
    </main>
  );
};
